import '../../scss/designer-details.scss';
